import { MainTabsV2 } from '@labrav/react-components'
import { settingsTabs } from '../FlyOutOnboardingWrapper/settingsTabs'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useTenantPartnerId, useUserType, usePartner } from '@labrav/common'
import { useStyles } from './FlyoutOffers.styles'
import PrivateOffersWrapperUIV2 from '../PrivateOffersWrapperUIV2/PrivateOffersWrapperUIV2'
import { ChannelOffers } from '../ChannelOffers/ChannelOffers'
import { keyToEnumValueMap } from './constants'
import type { FlyoutOffersProps } from './types'
import type { PrivateOfferListTrackingHandlers } from '../PrivateOffersWrapperUIV2/PrivateOffersWrapperUIV2'

const PrivateOffersListTab = ({
  className,
}: {
  className?: string
}) => {
  return (
    <div data-testid={'private-offers-content'} className={className}>
      <PrivateOffersWrapperUIV2 />
    </div>
  )
}

export const FlyoutOffers = (flyoutOffersProps: FlyoutOffersProps) => {
  const tenantPartnerId = useTenantPartnerId()
  const partnerUser = useUserType()
  const { classes } = useStyles()
  const { partnerData } = usePartner(tenantPartnerId || '', partnerUser)

  const partnershipType = (
    partnerData as { partnershipType?: string | string[] } | null
  )?.partnershipType
  const isCP = partnershipType?.includes('CONSULTING_PARTNER')

  const defaultTabs = [
    {
      key: 'private-offers',
      label: 'Private offers',
      path: 'private-offers',
      renderElement: (
        <PrivateOffersListTab
          className={classes.tabContent}
        />
      ),
    },
    {
      key: 'channel-offers',
      label: 'Channel offers',
      path: 'channel-offers',
      renderElement: (
        <div
          data-testid={'channel-offers-content'}
          className={classes.tabContent}
        >
          <ChannelOffers />
        </div>
      ),
    },
  ]

  const tabList = isCP
    ? defaultTabs.sort((itemOne, itemTwo) => {
        const itemOneValue = keyToEnumValueMap.get(itemOne.key) ?? 0
        const itemTwoValue = keyToEnumValueMap.get(itemTwo.key) ?? 0
        return itemTwoValue - itemOneValue
      })
    : defaultTabs

  const {
    defaultSettingsTabs,
    activeTab,
    handleTabChange,
    settingsTabsForRouting,
  } = settingsTabs([], tabList, true)

  return (
    <div className={classes.root}>
      <div className={classes.tabContainer}>
        <MainTabsV2
          tabs={defaultSettingsTabs}
          activeTabIndex={activeTab}
          onChange={handleTabChange}
          tabsType={'main'}
        />
      </div>
      <div className={classes.content}>
        <Suspense fallback={<div />}>
          <Routes>
            {settingsTabsForRouting.map(t => {
              return (
                <Route
                  key={t.path}
                  path={t.path}
                  element={t.renderElement ? t.renderElement : <></>}
                />
              )
            })}
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}
